import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuth from '../contexts/useAuth';
import { ADMIN_USERS } from '../utils/constants';

interface AdminProtectedRouteProps {
  children: React.ReactNode;
}

export const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({
  children,
}) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-allianz-light flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-allianz-primary mx-auto mb-4"></div>
          <p className="text-gray-600">Checking admin access...</p>
        </div>
      </div>
    );
  }

  // Check if user has Cognito authentication
  if (!user) {
    // Not logged in with Cognito - redirect to admin login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check if user is in admin list
  const username = user.username;
  if (!ADMIN_USERS.includes(username)) {
    // Authenticated but not an admin
    return (
      <div className="min-h-screen bg-allianz-light flex items-center justify-center">
        <div className="text-center bg-white p-8 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            Access Denied
          </h2>
          <p className="text-gray-600 mb-6">
            You do not have permission to access this page.
          </p>
          <a
            href="/"
            className="inline-block px-4 py-2 bg-allianz-primary text-white rounded-md hover:bg-allianz-secondary"
          >
            Return to Chat
          </a>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};
